import { connect } from 'react-redux';

const mapStateToProps = state => ({
  selectedLocations: state.mainreducer.selectedLocations,
});

export default FAQPageRightPart => connect(mapStateToProps, null)(FAQPageRightPart);
